import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-skin-analysis-validator"
    path="business/products/ai-skin-analysis-validator"
    element={<AsyncPage />}
  />,
];
